// extracted by mini-css-extract-plugin
export default {"indicator":"ActivityIndicator_indicator__oNONS","spin":"ActivityIndicator_spin__foCiK","light":"ActivityIndicator_light__Papx1","large":"ActivityIndicator_large__v98H+"};